module.exports = __webpack_public_path__ + "static/img/rightbj.44e3920.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/rightbj.png
// module id = 2dlZ
// module chunks = 0